// ContactUs.jsx
import React, { useRef, useEffect } from 'react';
import ContactUsForm from '../Components/Home/ContactUsForm'
import GoogleMap from '../Components/Home/GoogleMap'
import OfficeHours from '../Components/ContactUs/OfficeHours';
import AfterHours from '../Components/ContactUs/AfterHours';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigateAndScroll } from '../Hooks/useNavigateAndScroll';

function ContactUs() {
  const navigateAndScroll = useNavigateAndScroll();
  const navigate = useNavigate();
  const locations = useLocation();

  const handleNavigateAndScroll = (pathname, sectionId) => {
    if (locations.pathname !== pathname) {
      navigate(pathname);
    }

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Adjust the timeout as needed to ensure the page has navigated
  };

  const location = { 
    lat: 40.48090976182145,
    lng: -88.94729011428656,
    zoom: 18
  };

  const barRef = useRef(null);

  
  const goToExternalUrl = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    const handleScroll = () => {
      if (barRef.current) {
        const barTop = barRef.current.getBoundingClientRect().top;
        if (barTop <= 0) {
          barRef.current.classList.add('sticky', 'top-0', 'shadow-md');
        } else {
          barRef.current.classList.remove('sticky', 'top-0', 'shadow-md');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section && barRef.current) {
      const stickyBarHeight = barRef.current.offsetHeight;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY; // <= Use scrollY here
      const offset = 7;
      const scrollPosition = sectionPosition - stickyBarHeight - offset;
  
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
    }
  };
  return (
    <div>
    <div className="flex justify-center smartphone:hidden items-center relative"> 
    {/* //Relative position container for the image and text overlay */}
      <div className="relative w-auto z-1 mt-[-140px]">
        {/* // Image that fills the container */}
        <img className="w-full h-auto rounded-lg shadow-lg mt-2" 
             src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Contact_Usweb.webp" 
             alt="Children sitting with hands closed" />    
          
      </div>
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 smartphone:hidden">
            <button className="text-white font-bold bg-custom-regularOrange px-2 py-1 rounded-md hover:bg-custom-darkOrange"
            onClick={() => navigateAndScroll('/patient-center/new-patient')}>
              New to our practice - LET US HELP YOU
            </button>
          </div>

     

    </div>

    <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white">
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => scrollToSection('officeHours')}>Office Hours</button>
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => scrollToSection('generalEnquiries')}>General Enquiries</button>
        {/* <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => goToExternalUrl('https://healow.com/apps/practice/central-il-pediatric-assoc-llc-bloomington-il-10568?v=2&locale=en')}>Schedule Appointment</button> */}
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => scrollToSection('afterHours')}>After-hours Urgent Advice</button>
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => scrollToSection('officeLocation')}>Office Location</button>
      </div>

      <section className='bg-custom-darkBlue' id="officeHours">
        <OfficeHours />
      </section>
      <section id="generalEnquiries">
        <ContactUsForm />
      </section>
      <section id="scheduleAppointment">

      </section>
      <section id="afterHours">
        <AfterHours />
      </section>
      <section id="officeLocation">
         <GoogleMap lat={location.lat} lng={location.lng} zoom={location.zoom} />  
      </section>
    </div>
  
  );
}

export default ContactUs;